<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <mat-stepper
      #linearVerticalStepper="matVerticalStepper"
      formArrayName="scpis"
      [linear]="true"
      (selectionChange)="stepClick($event)"
    >
      @for (scpi of scpis.controls; track scpi; let i = $index) {
        <mat-step
          [formGroup]="scpi"
          [stepControl]="scpis?.get([i])"
          completed="false"
        >
          <ng-container formGroupName="parameters">
            <ng-template matStepLabel>{{
              scpi?.get('productName')?.value
            }}</ng-template>
            <div class="row row-flex">
              <div class="col col-md-12">
                <pr-input-radio
                  [derrors]="derrors"
                  formControlName="alreadyClientOfProduct"
                  columns="3"
                  [toggle]="true"
                  [isDefault]="false"
                  label="Etes-vous déjà client de ce produit ?"
                >
                </pr-input-radio>
              </div>
              @if (
                scpi?.get('parameters')?.get('alreadyClientOfProduct')?.value
              ) {
                <div class="col col-md-12">
                  <pr-input-column label="Identifiant" [derrors]="derrors">
                    <input
                      formControlName="clientIdentifiantForProduct"
                      type="text"
                    />
                  </pr-input-column>
                </div>
              }
            </div>
          </ng-container>
        </mat-step>
      }
    </mat-stepper>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
